import {Component} from '@angular/core';
import {NavController, NavParams, Tabs, ModalController, Events} from 'ionic-angular';
import {UserData} from '../../providers/user-data';
import {FirebaseData} from '../../providers/firebase-data';
import {LoginPage} from '../../modules/account/pages/login/login';
import {ModalDonateSubmit} from './components/modal-donate-submit'

@Component({
    selector: 'page-giving',
    template: `

        <ion-header>
          <ion-navbar>
            <ion-title class="no-padding">
              {{pageTitle}}
            </ion-title>
            <ion-buttons start>
              <button (click)="backToGivingHome($event)" *ngIf="showBackButton">
                <ion-icon name="arrow-back"></ion-icon>
                Back
              </button>
            </ion-buttons>
          </ion-navbar>
          <ion-toolbar no-border-bottom class="giving-toolbar">
            <ion-buttons class="text-center">
                <button (click)="makeADonation()" light outline>
                  <ion-icon name="heart"></ion-icon>
                  Make a Gift
                </button>
                <button (click)="gotoEvents()" light outline>
                  <ion-icon name="calendar"></ion-icon>
                  Event Calendar
                </button>
              </ion-buttons>
          </ion-toolbar>           
        </ion-header>
        <ion-content>
            <div class="text-center">          
                  <ion-spinner *ngIf="isLoading" name="dots"></ion-spinner>
            </div>
        </ion-content>
    `
})

export class GivingPage {
  private pageName: string;
  private tabs: Tabs;
  public pageTitle: any;
  public html:any;
  public isLoading: boolean = true;
  public currentUser: any;
  public donatePopup: any;


  constructor(
  	private nav: NavController,
    private params: NavParams,
    private events:Events,
  	private userData: UserData,
    private firebaseData: FirebaseData,
    private modalController: ModalController
  	) {
    this.pageName = this.params.get("name") || "giving-home";   
  }

  ionViewDidEnter() {
    let self = this;
    self.tabs = self.nav.parent;

    self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
      if(!isLoggedIn){        
        let tabs:Tabs = self.nav.parent;
        tabs.select(4);
        self.nav.setRoot(LoginPage);
      }else{
        self.userData.getUser().subscribe((user) => {
            self.currentUser = user;
            self.loadPageContent();            
        });        
      }
    });   
  }

  public loadPageContent(){
    let self = this;
    self.isLoading = true;
    self.firebaseData.get('/static-pages/' + self.pageName).subscribe(page => {
        if(page){
            self.pageTitle = page.title;
            self.html = page.body;
            self.isLoading = false;
        }
    });
  }

  public gotoEvents(){
    this.tabs.select(2);
  }

  public makeADonation(){
    this.donatePopup = this.modalController.create(ModalDonateSubmit, {user: this.currentUser});
    this.donatePopup.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/giving/giving.ts